import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FolderItemProps } from "apis/folder";
import { PaginationProps } from "utils/types/API";

interface FolderBreadcrumItemProps {
    id: number;
    name: string;
}
export interface FolderState {
    loading: boolean;
    list: {
        data: FolderItemProps[];
        breadcrum: FolderBreadcrumItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: FolderItemProps;
    };
}

const initialState: FolderState = {
    loading: false,
    list: {
        data: [],
        breadcrum: []
    },
    item: {
    }
};

interface IndexProps {
    data: FolderItemProps[];
    breadcrum: FolderBreadcrumItemProps[]
    pagination?: PaginationProps;
}

interface ItemProps {
    data?: FolderItemProps;
}

export const folderSlice = createSlice({
    name: "folder",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
            state.list.breadcrum = action.payload.breadcrum;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.list.data = action.payload.data ? [action.payload.data, ...state.list.data] : state.list.data;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
        remove: (state, action: PayloadAction<{ ids: number[] }>) => {
            state.loading = false;
            state.list.data = state.list.data.filter(folder => !action.payload.ids.includes(folder.id))
            state.list.breadcrum = state.list.breadcrum.filter(folder => !action.payload.ids.includes(folder.id))

        },
    },
});

export const { loading, endLoading, index, find, create, update, remove } = folderSlice.actions;
export default folderSlice.reducer;
